import { parse, startOfMonth } from 'date-fns';
import { PartnerFinanceMonthReport } from 'types/partnerFinance';
import { M8PartnerIncomeHistoryRecord } from '../types';
import { normalizeM8PartnerIncomeHistoryComissionItem } from './normalizeM8PartnerIncomeHistoryComissionItem';
import { normalizeM8PartnerIncomeHistoryPaymentItem } from './normalizeM8PartnerIncomeHistoryPaymentItem';

export const normalizeM8PartnerIncomeHistoryRecord = (
  m8PartnerIncomeHistoryRecord: M8PartnerIncomeHistoryRecord
) => {
  const { month, earned, payed, parts } = m8PartnerIncomeHistoryRecord;

  const monthDate = startOfMonth(parse(month, 'yyyy-LL', new Date()));

  return {
    toPartnerFinanceMonthReport(): PartnerFinanceMonthReport {
      return {
        earnedAmount: earned || 0,
        paidAmount: payed || 0,
        monthDateISO: monthDate.toISOString(),
        incomes: parts
          .map((part) => {
            if (part.type === 'COMISSION') {
              return normalizeM8PartnerIncomeHistoryComissionItem(
                part
              ).toPartnerFinanceMonthBillIncome();
            }

            return normalizeM8PartnerIncomeHistoryPaymentItem(
              part
            ).toPartnerFinanceMonthRewardIncome();
          })
          .sort((nextIncome, prevIncome) => {
            return (
              new Date(prevIncome.dateISO).getTime() -
              new Date(nextIncome.dateISO).getTime()
            );
          }),
      };
    },
  };
};
